import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import EarningGraph from "../../features/dashboard/earningGraph";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import CustomersGraph from "../../features/dashboard/customerGraph";
import BookingsGraph from "../../features/dashboard/issuesGraph";
import VenuesGraph from "../../features/dashboard/maintenanceTeamGraph";
import EarningsGraph from "../../features/dashboard/earningGraph";

const ManageAnalytics = () => {
  const navigate = useNavigate();

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Manage Analytics</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Analytics
          </p>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary">
            <DownloadIcon /> Export
          </Button>
        </div>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards">
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>$2000</h2>
          <p>Total Earning</p>
        </div>
      </div>
      <div className="grid_sc gap_m">
        <CustomersGraph />
        <BookingsGraph />
        <VenuesGraph />
        <EarningsGraph />
      </div>
    </MainContainer>
  );
};

export default ManageAnalytics;
